/**
 * Utilitários para manipulação de datas
 * Funções puras extraídas do App.js para melhor organização
 */

/**
 * Converte um número serial do Excel em uma data JavaScript
 * @param {number} serial - Número serial do Excel
 * @returns {Date|null} Data JavaScript ou null se inválido
 */
export function excelDateToJSDate(serial) {
  if (typeof serial === 'number') {
    const excelEpoch = new Date(Date.UTC(1899, 11, 30));
    const days = Math.floor(serial);
    const ms = days * 24 * 60 * 60 * 1000;
    const fractionalDay = serial - days;
    const msFraction = Math.round(fractionalDay * 24 * 60 * 60 * 1000);
    return new Date(excelEpoch.getTime() + ms + msFraction);
  }
  return null;
}

/**
 * Formata uma data de forma segura evitando problemas de timezone
 * @param {Date} date - Data para formatar
 * @returns {string} Data formatada em YYYY-MM-DD ou o valor original se não for Date
 */
export function formatDateSafe(date) {
  if (date instanceof Date) {
    return `${date.getUTCFullYear()}-${String(date.getUTCMonth() + 1).padStart(2, '0')}-${String(date.getUTCDate()).padStart(2, '0')}`;
  }
  return date;
}
